import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { ISearchFacets } from "@shared/lib/types/briefInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefInfluencerSearchFacetsByStatus(
  briefId: string,
  status: string
) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<ISearchFacets>
  >({
    queryKey: [
      ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
      "facets",
      briefId,
      status,
    ],
    queryFn: () =>
      BriefService.getBriefInfluencerSearchFacetsBystatus(briefId, status),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    searchFacets: data?.data,
    isFetching: isLoading,
  };
}
